import enLocale from '@ods/ods/lib/locale/lang/en'

export default {
  ...enLocale,
  label: 'English',
  labelMobile: 'EN',
  serverError: 'Unexpected server error. Try again.',
  noResults: 'No results found',
  close: 'close',
  login: {
    title: 'Login',
    user: 'Username',
    password: 'Password',
    submitButton: 'Send',
    rules: {
      user: 'Please, type a user name',
      password: 'Please, type a password'
    },
    logging: 'Loading...',
    loginErrorTitle: 'Validation Error',
    loginError: 'Invalid user or wrong password.',
    forgotPassword: 'Forgot your password?',
    keepMeLogged: 'Keep me logged in',
    login: 'Login',
    // footerLinks: ['faq', 'terms', 'conditions'],
    footerLinks: [],
    social: {
      title: 'Login with'
    }
  },
  password: {
    title: 'Reset password',
    message: 'Type your account\'s email to proceed',
    email: 'Email',
    submitButton: 'Submit',
    goBack: 'Go back',
    error: 'Email not found',
    sending: 'Sending...',
    rules: {
      email: 'Email not found'
    },
    emailSubmitted: 'We\'ve sent an email with the instructions to reset your password to: ',
    done: 'Finish',
    emailError: 'We can\'t find any account with this email:'
  },
  notifications: {
    popoverTitle: 'Notifications'
  },
  breadcrumb: {
    home: 'Home',
    dashboard: 'Portal User',
    comercio: 'Commerce',
    comercios: 'Commerces',
    tasks: 'Tasks',
    users: 'Users',
    randomUser: 'Random user ',
    randomString: 'Random string param: ',
    editProfile: 'Edit user',
    myUser: 'My user',
    editUser: 'Edit user',
    info: 'Commerce',
    recibos: 'Receipts',
    facturas: 'Bills',
    loyalty: 'Loyalty',
    programs: 'Programs',
    accounts: 'Accounts',
    coupons: 'Coupons',
    marketing: 'Marketing',
    Analytics: 'Analytics',
    clients: 'Clients',
    TemplatesDetails: 'Templates',
    CouponsAsing: 'Assign coupon'
  },
  dashboard: {
    chains: 'Chains',
    businesses: 'Businesses',
    searchHere: 'Search here'
  },
  commerceInfo: {
    codeInCommerce: 'Internal code of commerce',
    chain: 'Chain',
    address: 'Address',
    status: 'Status',
    product: 'Product',
    rateType: 'Rate of Type',
    ratesGeneral: 'General Rates',
    ratesCards: 'Card types Rates',
    ratesFinancing: 'Financing types Rates',
    ratesRappel: 'Rappel Rates',
    listVendors: 'Seller list',
    SellerRegistration: 'Seller Registration',
    listRequests: 'List of requests',
    listFinancing: 'Financing List',
    users: 'Users',
    staff: 'Staff',
    terminalsInquiries: 'Terminals',
    terminals: 'QR Terminals',
    commerceTPV: 'Commerce TPV',
    movements: 'Movements',
    dataSeller: 'Data Seller',
    ContactInformation: 'Contact Information',
    bankData: 'Bank Data',
    modifyData: 'Modify Data',
    editData: 'Edit Data',
    accept: 'Accept',
    commissions: 'Commissions',
    rappel: 'Rappel',
    vendors: 'Vendors',
    requests: 'Requests',
    financing: 'Financing'
  },
  loyalty: {
    programsDescription: 'Here you can view your loyalty programmes and their detailed settings.',
    accountsDescription: 'Here you can see the accounts associated with your loyalty programme, their status, movements and details of the points that have been accumulated, redeemed and cancelled.',
    couponsDescription: 'Here you can view the different types of coupons associated with your loyalty program, which coupons have been used, which accounts have redeemed and assign coupons to the loyalty accounts of your choice.',
    marketingDescription: 'Here you can generate automatic actions to contact customers. You will be able to segment the customers to whom you want to send communications or assign coupons automatically.',
    AnalyticsDescription: 'Here you can view a dashboard to see how your loyalty program is evolving.',
    generalData: 'Main data',
    codprog: 'Program code',
    description: 'Description',
    validity: 'Validity',
    equivalenceRatio: 'Equivalence ratio',
    typeAccount: 'Type of account',
    since: 'Since',
    until: 'until',
    realtimepointinf: 'Information about points in real time',
    operationaldata: 'Operational data',
    Bankstatement: 'Bank statement',
    mailstatement: 'Mailing statement',
    nextreleasedate: 'Next remit date',
    maximumpoints: 'Maximum points',
    points: 'Points',
    expirationcriteria: 'Expiration criteria',
    periodicity: 'Periodicity of review of expired points',
    automaticaward: 'Automatic award',
    catalog: 'Catalog',
    cancelpointafteraward: 'Cancellation of points after award',
    redemptionperiodicity: 'Periodicity of redemption',
    lastredemtion: 'Last redemtion',
    nextredemtion: 'Next redemtion',
    immediateReward: 'Immediate reward indicator',
    periodValidity: 'Period of validity',
    pointsTransferIndicator: 'Point transfer indicator',
    commerces: 'Commerces',
    channel: 'Channels',
    chanelpercentage: 'Chanel percentage',
    emitterpercentage: 'Emiter percentage',
    code: 'Code',
    search: 'Search',
    holding: 'Holding',
    commercialchain: 'Commercial chain',
    storecode: 'Store code',
    commerce: 'Commerce',
    allCounts: 'All counts',
    activeCounts: 'Active accounts without blocking',
    blockedAccount: 'Active accounts with redemption and/or accrual blocking',
    closedAccount: 'Closed accounts',
    loyaltyAccount: 'Loyalty Account',
    accounts: 'Accounts',
    account: 'Account',
    client: 'Client',
    Idtype: 'Identifier type',
    IdNumber: 'ID Client',
    State: 'State',
    currentstate: 'Current state',
    accumulationBlockage: 'BLOCK. Accumulation',
    redeemableLock: 'Block Redeemable',
    totalPoints: 'Total points',
    pointsDetails: 'Points detail',
    transactions: 'Transactions',
    availablePoints: 'Avaiable points',
    opened: 'Active',
    blocked: 'Blocked',
    closed: 'Closed',
    totalPointsAccumulated: 'Total points accumulated',
    totalDefCancelPoints: 'total definitive canceled points',
    totalPointsExceeded: 'Total points exceeded',
    totalPointsExpired: 'Total Points Expired',
    totalPointsRetainedManually: 'Total points retained manually',
    totalPointsRetainStandby: 'Total points retain in standby',
    totalPointsRetainBlockage: 'Total points retain due to blockage',
    date: 'Date',
    concept: 'Concept',
    accumulablePointsMovements: 'Accumulable pts',
    avaiablePointsMovements: 'Avaiable pts',
    accumulablePoints: 'Accumulable points',
    avaiablePoints: 'Avaiable points',
    Cumulative: 'Cumulative',
    HoldInStandby: 'Hold in standby',
    ManualHold: 'Manual hold',
    HeldByBlocking: 'Held by blocking',
    Released: 'Released',
    DefinitiveAnnulled: 'Definitive annulled',
    Expired: 'Expired',
    Informative: 'Informative',
    FullyRedeemed: 'Fully redeemed',
    TransferredToAnotherAccount: 'Transferred to another account',
    CancelledAfterAutomaticAward: 'Cancelled after automatic award',
    Exceeded: 'Exceeded',
    Penalized: 'Penalized',
    noData: 'No data',
    newAccount: 'New account',
    noExpirationDate: 'No expiration date',
    directedOlder: 'Directed by oldest',
    directedNewest: 'Directed by newer',
    customerCategory: 'By customer category',
    seePointsDetails: 'View detail of points',
    yes: 'YES',
    no: 'NO',
    personalData: 'Personal data',
    documentType: 'Type of document',
    name: 'Name',
    firstName: 'First name',
    lastName: 'Last name',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    adress: 'Adress',
    region: 'Region',
    city: 'City',
    postalCode: 'Postal code',
    email: 'Email',
    dni: 'ID Client',
    phone: 'Phone',
    checkDNI: 'Check ID number',
    cancel: 'Cancel',
    requiredFields: '(*) Required fields',
    advancedSearch: 'Advanced search',
    startDate: 'Start date',
    endDate: 'End date',
    automaticRedemption: 'Automatic Redemption',
    manualRedemption: 'Manual Redemption',
    apply: 'Apply',
    save: 'Save',
    totalPointsAvaible: 'Total points available',
    totalAccumulatedPoints: 'Total accumulated points',
    totalDefinitiveAnnulledPoints: 'Total definitive annulled points',
    totalManualRetainedPoints: 'Total manual retained points',
    totalPointsHeldSuspense: 'Total points held in suspense',
    totalPointsWithheldBlockage: 'Total points withheld due to blockage',
    totalPointsReleased: 'Total points released',
    totalPointsPenalized: 'Total points penalized',
    totalPointsRedeemed: 'Total points redeemed',
    currentStatus: 'Current status',
    userExist: 'Existing user',
    userNotExist: 'The client does not exist',
    continue: 'Continue',
    createAccount: 'Account created correctly',
    create: 'Create',
    logout: 'Logout',
    requireField: 'Required field',
    invalidFormat: 'Format invalid',
    birthDate: 'Birth Date',
    maritalStatus: 'Marital status',
    maritalStatusArr: ['Select marital status', 'Single', 'Married', 'Widow', 'Divorced', 'Separated', 'Convivence'],
    notAllowedCharacters: 'Characters not allowed',
    typeIdentif: 'Type identif.',
    templates: 'Templates',
    assignment: 'Assignment',
    liquidation: 'Liquidation',
    minimumAmount: 'Minimum Amount',
    maxCoupon: 'Máx. Coupons',
    couponsAssigned: 'Coupons Assigned',
    TemplatesDetails2: 'Template Detail',
    mainData: 'Main data',
    configuration: 'Configuration',
    couponCoversion: 'Coupon Conversion',
    program: 'Program',
    templateTitle: 'Template title',
    BasedOnBonus: 'Based on bonus',
    subtitle: 'Subtitle',
    couponCoins: 'Coupon coins',
    pointToRedeemed: 'Points to be redeemed',
    amountValue: 'Amount value',
    roundToPoints: 'round off units greater than points',
    valueType: 'Value type',
    discountvalue: 'Discount value',
    chanelUse: 'Chanel used',
    minImp: 'Minimum purchase amount',
    maxBon: 'Maximum bonus amount',
    maxCoupons: 'Maximum amount of coupons',
    tranferCoupon: 'allow transfer of coupons',
    defaultState: 'Default coupon status',
    oneCommerce: 'One single commerce',
    commerceamount: 'Amount contributed by the commerce',
    preview: 'Preview',
    in: 'in',
    valid: 'Valid',
    coupons: 'Coupons',
    totalCoupon: 'Total Coupons',
    couponsUsed: 'Coupons used',
    couponsUnused: 'Coupons unused',
    asignedcoupons: 'Asigned coupons',
    template: 'Template',
    identifier: 'identificator',
    AsignedCouponDate: 'Asigned coupon date',
    DateUseCoupon: 'Date of use',
    CouponSituation: 'Coupon Situation',
    used: 'Used',
    notUsed: 'Not used',
    sincede: 'Since',
    untilde: 'until',
    assignCoupon: 'Assign coupon',
    clean: 'Clean',
    singlechannel: 'Channel',
    select: 'Select',
    Permanent: 'Permanent',
    Percentage: 'Percentage',
    CouponsAsing: 'Assign coupon to {alaplantilla}',
    selectTemplate: 'Select template ({pag}/2)',
    selectOneTemplate: 'Select the template to asign',
    prev: 'Previous',
    next: 'Next',
    viewCoupon: 'Coupon preview',
    viewSelectedCoupon: 'Selected coupon preview',
    selectAccountsCoupon: 'Select accounts for the coupon {nombrecupon} (2/2)',
    selectAccountsCouponDesc: 'Select 20 accounts maximum to append each time. ',
    analytics: {
      working: '(working on it)',
      lastWeek: 'Last 7 days',
      lastWeekWarning: 'The date {startDate} has changed to 7 days before {endDate}. Only 7 days periods allowed.',
      allClients: 'All clients',
      allAccounts: 'All accounts created, blocked and/or closed for this period',
      activeAccounts: 'Accounts created for this period',
      blockedAccounts: 'Accounts blocked for this period',
      closedAccounts: 'Accounts closed for this period',
      infoAccounts: 'For this period of time, an account could have various status.',
      active: 'Created',
      blocked: 'Blocked',
      closed: 'Closed',
      affectedAccounts: '{total} status changes for {totalreal} account(s) in the period',
      affectedTotalAccounts: 'over {total} accounts',
      regCllients: 'Registered clients in the period',
      men: 'Men',
      noinfo: 'Uninformed',
      women: 'Women',
      xAxisName: '7 days untill {endDate}',
      clientDetails: 'Client Detalis'
    }
  }
}
